import React, { useMemo } from 'react';
import CentralSwitchEmptyState from 'flow/components/central-switch/CentralSwitchEmptyState';
import CentralSwitchHeader from 'flow/components/central-switch/CentralSwitchHeader';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { sortFavorites } from 'flow/utils/favorite-utils';
import { TypedMap } from 'flow/types/TypedMap';
import { Favorite } from 'flow/types/Favorite';
import { selectExtensionAndContactFavorites } from 'flow/selectors/favorite-selectors';
import FavoriteItem from './FavoriteItem';

const FavoriteContactsCentralSwitchWidget = () => {
    const { i18next } = useAppContext();
    const MAXIMUM_TO_SHOW = 10;

    const favorites = useAppSelector(selectExtensionAndContactFavorites);
    const sortedFavorites = useMemo(
        () => sortFavorites(favorites),
        [favorites],
    );

    const getContent = () => {
        if (!favorites?.size) {
            return <CentralSwitchEmptyState uniqueId={'FavoriteContacts'} />;
        }
        return (
            <main>
                <ul className="px-4 pb-4">
                    {sortedFavorites
                        .take(MAXIMUM_TO_SHOW)
                        .map((favorite: TypedMap<Favorite>) => (
                            <FavoriteItem
                                key={favorite.get('key')}
                                favorite={favorite}
                            />
                        ))
                        .valueSeq()}
                </ul>
            </main>
        );
    };

    return (
        <>
            <CentralSwitchHeader>
                {i18next.t('central_switch.favorite_contacts.description')}
            </CentralSwitchHeader>
            {getContent()}
            {favorites.size > MAXIMUM_TO_SHOW && (
                <div className="mb-4 h-6 px-4 text-end text-sm text-gray-400">{`+ ${
                    favorites.size - MAXIMUM_TO_SHOW
                } ${i18next.t('more')}`}</div>
            )}
        </>
    );
};

export default FavoriteContactsCentralSwitchWidget;
